export default {
  "Autocomplete.all_number_selected": "Tous les {number} sélectionnés",
  "Autocomplete.all_number": "Tout ({number})",
  "Card.toggle_content": "basculer le contenu",
  "Chip.remove": "supprimer",
  "DatePicker.next": "Prochain",
  "DatePicker.previous": "Précédent",
  "Pagination.first": "premier",
  "Pagination.go_to_page_number": "Aller à la page {index}",
  "Pagination.go_to_page": "Aller à la {label} page",
  "Pagination.last": "Dernier",
  "Pagination.next": "Prochain",
  "Pagination.previous": "Précédent",
  "Table.actions": "Tableau des actions",
  "Table.add_column": "Ajouter une colonne",
  "Table.clear_selection": "Éffacer séléction",
  "Table.filter": "Filtre",
  "Table.hide": "Cacher",
  "Table.more_actions": "Plus d'actions",
  "Table.move_left": "Déplacer à gauche",
  "Table.move_right": "Déplacer vers la droite",
  "Table.pagination": "Pagination des tableaux",
  "Table.pagination_loading": "Contrôles de pagination du tableau de chargement",
  "Table.per_page": "Par page",
  "Table.position_zero": "0 sur {total}",
  "Table.position": "{start}-{end} sur {total}",
  "Table.search": "Chercher",
  "Table.select_all": "Tout sélectionner",
  "Table.select_all_n": "Tout choisir {count}",
  "Table.select_row": "Sélectionnez {row}",
  "Table.sort_ascending": "Trier par ordre croissant",
  "Table.sort_descending": "Trier par ordre décroissant",
  "TextInput.clear_labelled_input": "Effacer {label}",
  "Ui.clear_all": "Tout effacer",
  "Ui.close": "Proche",
  "Ui.loading": "Chargement",
  "Ui.no_results": "Aucun résultat",
  "Ui.number_selected": "{number} sélectionnés",
  "Ui.remove": "Éliminer",
  "Ui.select_all": "Tout sélectionner",
  "Ui.show_more": "+ {count} Plus",
}
